import React, { useEffect } from 'react';
import './EvaluationScreen.less';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { jobsActions, jobsSelectors } from '../../redux/jobs';
import { useIsCompactLayout } from '../../helper/LayoutHelper';
import { useParams } from 'react-router';
import Loading from '../../components/common/Loading/Loading';
import SideBarLayout from '../MainScreen/SideBarLayout';
import BasicScreen from '../common/BasicScreen/BasicScreen';
import JobSearchToolbarItem from '../JobsScreen/components/JobFilterToolbar/JobSearchToolbarItem';
import EvaluatedMeterDetails from './components/EvaluatedMeterDetails';
import Empty from '../../components/envago/Empty/Empty';
import EvaluatedJobList from './components/EvaluatedJobList';
import { applicationSelectors } from '../../redux/application';
import { Helmet } from 'react-helmet-async';
import JobFilterToolbar from '../JobsScreen/components/JobFilterToolbar/JobFilterToolbar';

const EvaluationScreen = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(jobsActions.loadJobs());
    }, [dispatch]);

    const isEvaluationEnabled = useSelector(applicationSelectors.isEvaluationEnabled);
    const isLoading = useSelector(jobsSelectors.isLoading);
    const jobs = useSelector(jobsSelectors.getFilteredJobs);

    const isCompactLayout = useIsCompactLayout();

    // Routes: /auswertung (list) and /auswertung/:jobId (details)
    const { jobId } = useParams<{ jobId?: string }>();
    const applicationName = useSelector(applicationSelectors.getApplicationName);


    if (!isEvaluationEnabled) return null;

    return (
        <>
            {isLoading && (
                <div className={'flex-1 p-4'}>
                    <Loading size={50} text={t('common.loadingJobs')} />
                </div>
            )}

            {!isLoading && !isCompactLayout && (
                <SideBarLayout
                    sidebar={
                        <BasicScreen>
                            <JobFilterToolbar />
                            <EvaluatedJobList jobs={jobs} />
                        </BasicScreen>
                    }
                >
                    {!jobId && (
                        <>
                            <Helmet>
                                <title>{applicationName} | Auswertung</title>
                            </Helmet>
                            <div className={'mt-20'}>
                                <Empty showIcon>{t('evaluation.hint')}</Empty>
                            </div>
                        </>
                    )}
                    {jobId && <EvaluatedMeterDetails jobId={jobId} />}
                </SideBarLayout>
            )}

            {!isLoading && isCompactLayout && !jobId && (
                <BasicScreen>
                    <JobFilterToolbar />
                    <EvaluatedJobList jobs={jobs} />
                </BasicScreen>
            )}
            {!isLoading && isCompactLayout && jobId && <EvaluatedMeterDetails jobId={jobId} />}
        </>
    );
};

export default EvaluationScreen;
